import { AdminCustomerListModel } from '../../models'
import { AdminCustomerListDto } from '../dto/admin-customer-list.dto'

const fromDtoToModelTransformer = (dto: AdminCustomerListDto): AdminCustomerListModel[] => {
  return dto['company.sapCustomerID'].map((id, index) => ({
    sapCustomerId: id,
    userId: dto['user.ID'][index],
    username: dto['user.username'][index],
    companyName: dto['company.Name'][index],
  }))
}

export default fromDtoToModelTransformer
